import { action } from 'typesafe-actions';
import {
  OWNED_BETS_FAILURE,
  OWNED_BETS_REQUEST,
  OWNED_BETS_SUCCESS,
} from '../../constants/ownedBets';

export const ownedBetsRequestAction = (openstatus: any) =>
  action(OWNED_BETS_REQUEST, { openstatus: openstatus });
export const ownedBetsSuccessAction = (data: any, openstatus: any) =>
  action(OWNED_BETS_SUCCESS, {
    data: data,
    openstatus: openstatus.payload.openstatus,
  });
export const ownedBetsFailureAction = (e: any) => action(OWNED_BETS_FAILURE, e);

export const ownedBetsActions = {
  ownedBetsRequestAction,
  ownedBetsSuccessAction,
  ownedBetsFailureAction,
};
